/* eslint-disable no-multi-spaces */
import React, { useContext, useReducer, useEffect, createContext } from 'react'
import { ApplicationContext } from '@contexts/ApplicationContext'
import reducer, { propsToState } from './reducer'
import { actionCreators } from './actions'

export const LiabilitiesContext = createContext({})

export const LiabilitiesProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [internalState, dispatch]   = useReducer(reducer, propsToState(props))
  const stateWithProps = { ...props, ...internalState }
  const actionsWithDispatch = actionCreators(dispatch, stateWithProps)
  const { updateProps }     = actionsWithDispatch

  useEffect(
    () => updateProps(props),
    [props.liabilities]
  )

  return (
    <LiabilitiesContext.Provider value={{ state: stateWithProps, trackingDetails, actions: actionsWithDispatch }}>
      {props.children}
    </LiabilitiesContext.Provider>
  )
}
